module.exports = __webpack_public_path__ + "static/media/gif_agenda.805aab12.gif";